import {Service} from "@/services/superclasses/service";
import {FormResponse} from "@/interfaces/form-response";
import {HelpAnswer} from "@/interfaces/help-answer";
import {HelpCategory} from "@/interfaces/help-category";
import {HelpTopic} from "@/interfaces/help-topic";
import {MemberContactUs} from "@/interfaces/member-contact-us";

const api = window.contextPath + "/rest/memberhelp";

export class MemberHelpService extends Service {

    public sendQuestion = async (data: MemberContactUs): Promise<FormResponse<MemberContactUs>> => {
        return this.data(await this.post<FormResponse<MemberContactUs>>(api + "/contact-us", data))
    }

    public getAnswerById = async (queryparam: string, id: number): Promise<FormResponse<HelpAnswer>> => {
        return this.data(await this.get<FormResponse<HelpAnswer>>(api + "/answer" + queryparam + id))
    }

    public getTopics = async (): Promise<FormResponse<Array<HelpTopic>>> => {
        return this.data(await this.get<FormResponse<Array<HelpTopic>>>(api + "/topics"))
    }

    public getCategories = async (): Promise<FormResponse<Array<HelpCategory>>> => {
        return this.data(await this.get<FormResponse<Array<HelpCategory>>>(api + "/categories"))
    }

    public getCategoryFromQuestionId = async (queryparam: string, questionId: number): Promise<FormResponse<HelpCategory>> => {
        return this.data(await this.get<FormResponse<HelpCategory>>(api + "/category" + queryparam + questionId))
    }
}

export const memberHelpService = new MemberHelpService();